import React, { ChangeEvent } from 'react';
import styles from './mobileSuperAdminOrganisationsToolbar.module.scss';
import SearchInput from '@source/components/UI/inputs/searchInput/searchInput';
import { IFillVariant } from '@source/utils/enums';

interface MobileSuperAdminOrganisationsToolbarProps {
  search: string;
  onSearchChange: (e: ChangeEvent<HTMLInputElement>) => void;
  rowsTotalCount: number;
}

const MobileSuperAdminOrganisationsToolbar = (props: MobileSuperAdminOrganisationsToolbarProps) => {
  const { search, onSearchChange, rowsTotalCount } = props;

  return (
    <div className={styles.mobileToolbar}>
      {/* Top Bar */}
      <div className={styles.topBar}>
        <div className={styles.countSection}>
          <span className={styles.count}>
            {rowsTotalCount} Organizations
          </span>
        </div>
      </div>

      {/* Search Bar */}
      <div className={styles.searchBar}>
        <SearchInput
          className={styles.searchInput}
          value={search}
          onChange={onSearchChange}
          fill={IFillVariant.Fill}
          placeHolder="Search..."
        />
      </div>
    </div>
  );
};

export default MobileSuperAdminOrganisationsToolbar;
